import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  openSubscriptionPayment,
  SUBSCRIPTION_BILLING_PAGE_PATH,
  subscriptionBillingPayPath,
} from '../../utils/subscriptionBilling.js';

/**
 * @param {{ tenantId?: number | null, className?: string, children: import('react').ReactNode, payNow?: boolean }} props
 */
export function AdminSubscriptionPortalLink({ tenantId, className, children, payNow = false }) {
  const to =
    payNow && tenantId != null && Number(tenantId) > 0
      ? subscriptionBillingPayPath(Number(tenantId))
      : SUBSCRIPTION_BILLING_PAGE_PATH;

  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
}

/**
 * @param {{ tenantId: number | null | undefined, className?: string, label?: string, disabled?: boolean }} props
 */
export function AdminSubscriptionPayButton({
  tenantId,
  className,
  label = 'Pagar no portal',
  disabled = false,
}) {
  const [busy, setBusy] = useState(false);
  const tid = Number(tenantId);

  async function handlePay() {
    if (!Number.isFinite(tid) || tid <= 0 || busy || disabled) return;
    setBusy(true);
    try {
      const url = await openSubscriptionPayment(tid);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      const msg = err instanceof Error ? err.message : 'Não foi possível iniciar o pagamento.';
      window.alert(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" onClick={handlePay} disabled={busy || disabled || !Number.isFinite(tid) || tid <= 0} className={className}>
      {busy ? 'A preparar checkout…' : label}
    </button>
  );
}
